module.exports = __webpack_public_path__ + "static/img/Application.e6e78bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/miximo/imgs/browse/Application.jpg
// module id = 1760
// module chunks = 0